export class ApiClientError extends Error {
  constructor(readonly status: number, message: string, readonly code?: string) {
    super(message);
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const method = (init?.method || 'GET').toUpperCase();
  const mutating = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method);
  const response = await fetch(`/api${path}`, {
    credentials: 'include',
    ...init,
    headers: {
      ...(init?.body && !(init.body instanceof FormData) ? { 'content-type': 'application/json' } : {}),
      ...(mutating ? { 'Idempotency-Key': crypto.randomUUID() } : {}),
      ...init?.headers,
    },
  });
  const body = await response.json().catch(() => null) as { data?: T; error?: { message?: string; code?: string } } | null;
  if (!response.ok) throw new ApiClientError(response.status, body?.error?.message || `Request failed (${response.status})`, body?.error?.code);
  return body?.data as T;
}

export function mutationHeaders() {
  return { 'Idempotency-Key': crypto.randomUUID() };
}
